import React from 'react'
import clickMyLoanImage from '../images/clickmyloan_logo.svg';

export default function Navbar() {
  return (

    <div className='navbar'>
    <img src={clickMyLoanImage}></img>
    </div>
    
  )
}
